import "./UserSummary.css";
import SummaryCard from "../../components/summaryCard/SummaryCard.jsx";
import SummaryChartCard from "../../components/summaryChartCard/SummaryChartCard.jsx";
import SearchSection from "../../components/searchSection/SearchSection.jsx";
import DefaultProfileImage from "../../medias/images/default.jpg"
import { useParams } from "react-router-dom";
import React, { use, useEffect, useState } from 'react';
import moment from 'moment';
import UserShortProfile from "../../components/userShortProfile/UserShortProfile.jsx";
import LoadingSpinner from "../../components/loadSpinner/LoadingSpinner.jsx";
import { getUserSummaryRequest } from "../../services/wisdomServices/reportService";
import { getAchievements, getUserInformations } from "../../services/wisdomServices/userService";
import { requestGetImagesFromBucket } from "../../services/wisdomServices/trackingService";
import { FloatLabel } from "primereact/floatlabel";
import { Calendar } from "primereact/calendar";
import { SelectButton } from "primereact/selectbutton";
import { Message } from "primereact/message";
import ManagerSubHeaderLinks from "../../components/managerSubHeaderLinks/ManagerSubHeaderLinks.jsx"
import { Card } from "primereact/card";
import { getAgentProjectsRequest } from "../../services/wisdomServices/projectService.js";
import { getUserSpecsRequest } from "../../services/trackerServices/trackerService.js";

/**
 * @function UserSummary
 * @returns {JSX.Element} - user summary dashboard
 */
function UserSummary() {
  const today = new Date()
  const [user,setUser] = useState(null);
  const [totalTime, setTotalTime] = useState(0);
  const [projects, setProjects] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(true);
  const [achivements, setAchievements] = useState([]);
  const [loadingAchivements, setLoadingAchivements] = useState(true);
  const [specs, setSpecs] = useState(null);
  const [loadingSpecs, setLoadingSpecs] = useState(true);
  const [activeTime, setActiveTime] = useState(0);
  const [idleTime, setIdleTime] = useState(0);
  const [markedTime, setMarkedTime] = useState(0);
  const [manualTime, setManualTime] = useState(0);
  const [approvedOT, setApprovedOT] = useState(0);
  const [rejectedTime, setRejectedTime] = useState(0);
  const [overtime, setOvertime] = useState(0);
  const [loading, setLoading] = useState(true)
  const [dates, setDates] = useState([
      today,
      today
  ]);
  const items = [
    {name: 'Daily', value:1},
    {name: 'Weekly', value:2},
    {name: 'Monthly', value:3}
  ]
  const [selectedPeriod, setSelectedPeriod] = useState(1)
  const params = useParams();
  if(user !== null){
    if(user.image == null)
      user.image = "default";

  }

  useEffect(() => {
    loadUserProjects()
    loadUserSpecs()
    loadCourses()
  }, [])

  useEffect(() => {
    getUser();
    getSummaryDetails(dates);

  }, [])

  const loadCourses = async() => {
    try {
      setLoadingAchivements(true)
      const response = await getAchievements(params.employeeId)
      setAchievements(response)
    } catch (error) {
      console.error("Something went wrong loading user's completed achivements: ", error)
    } finally {
      setLoadingAchivements(false)

    }
  }

  const loadUserProjects = async() => {
    try {
      setLoadingProjects(true);
      const response = await getAgentProjectsRequest(params.employeeId, false, false);
      setProjects(response.data);
    } catch (error) {
      console.error(error);

    } finally {
      setLoadingProjects(false);

    }
  }

  const loadUserSpecs = async() => {
    try {
      setLoadingSpecs(true);
      const response = await getUserSpecsRequest(params.employeeId);
      setSpecs(response?.specs?.[0]);
    } catch (error) {
      console.error(error);

    } finally {
      setLoadingSpecs(false);

    } 
  }

  /**
   * @async
   * @function getUser
   * @description - fetches user profile data and profile image
   */
  const getUser = async () => {
    let u = await getUserInformations(params.employeeId);

    if (!u.image) {
      u.image = DefaultProfileImage;
    } else {
      const blob = await requestGetImagesFromBucket(
        u.id,
        u.image,
        "profile"
      );

      u.image = blob
        ? URL.createObjectURL(blob)
        : DefaultProfileImage;
    }

    setUser(u);
    setLoading(false);
  };

  const handlePeriodChange = (e) => {
    const value = e.value;
    setSelectedPeriod(value);

    const today = moment();
    let range = [];

    switch (value) {
      case 1:
        range = [
          today.toDate(),
          today.toDate()
        ];
        break;

      case 2:
        range = [
          today.clone().startOf("isoWeek").toDate(),
          today.toDate()
        ];
        break;

      case 3:
        range = [
          today.clone().startOf("month").toDate(),
          today.toDate()
        ];
        break;

      default:
        return;
    }
  
    setDates(range);
    getSummaryDetails(range);
  };

  /**
   * @async
   * @function getSummaryDetails
   * @description - fetches summarized tracking data for the selected date range
  */
  const getSummaryDetails = async (range) => {
    if (!range?.[0] || !range?.[1]) return;
    try {
      const start = moment(range[0]).format("YYYY-MM-DD");
      const end = moment(range[1]).format("YYYY-MM-DD");
  
      const summary = await getUserSummaryRequest(
        params.employeeId,
        start,
        end
      );
  
      setTotalTime(summary.totalTime);
      setActiveTime(summary.activeTime);
      setIdleTime(summary.idleTime);
      setMarkedTime(summary.markedCards)
      setManualTime(summary.requested);
      setApprovedOT(summary.approvedOt);
      setRejectedTime(summary.rejectedTime);
      setOvertime(summary.overtime);
      
    } catch (error) {
      console.error(error)
    }
  };

  
  const handleDateRangeSelection = async(e) => {
    setDates(e.value)
    getSummaryDetails(e.value);
  }
  
  return (
    <div className="summary">
      {loading && (
        <div className="loading-label">
          <LoadingSpinner />
        </div>
      )}
      {!loading && (
        <>
          <div className="employee-summary-main">
            <div className="my-dashboard-header">
              <UserShortProfile
                employeeName={user.firstName + ' ' + user.lastName}
                employeePronoun={user.pronoun}
                employeeDesignation={user.jobDescription}
                employeeID={user.id}
                employeeUsername={user.username}
                employeeLocation={user.city}
                employeePicture={user.image}
                employeeDisabled={user.isDisabled}
                employeeContractEndDate={user.contractEndDate}
                employeeDepartment={user.department}
                employeeIdvStatus={user.trolleyIdvStatus}
                employeePersonalEmail={user.personalEmail}
                showManagerLinks={true}
              />
            </div>
            <div className="employee-summary-box">
              <div className="">
                <div className="employee-summary-info">
                  <div className="employee-summary-cards-box">
                    <div className="manager-view-employee-summary-input-group">
                      <div className="mananger-view-calendar-input-group">
                        <div>
                          <FloatLabel>
                            <Calendar 
                              value={dates} 
                              inputId="user-summary-date-range-selector" 
                              onChange={handleDateRangeSelection} 
                              selectionMode="range" 
                              readOnlyInput 
                              hideOnRangeSelection
                              selectOtherMonths={true}
                            />
                            <label htmlFor="user-summary-date-range-selector">Select a date range</label>
                          </FloatLabel>
                        </div>
                        <div>
                          <Message severity="info" text="All time in the summary is on the UTC timezone"/>
                        </div>
                      </div>
                      <div>
                        <SelectButton options={items} value={selectedPeriod} onChange={handlePeriodChange} optionLabel="name"/>
                      </div>
                    </div>
                    <div className="manager-view-user-summary-cards">
                      <div className="manager-view-employee-summary-cards">
                        <SummaryCard title="Tracked Time" cardtime={activeTime} info='Your total tracked time via the wisdom tracker.'/>
                        <SummaryCard title="Idle Time" cardtime={idleTime} info=' Your total Idle time, idle timecards are the ones without activity.'/>
                        <SummaryCard title="Manual Time" cardtime={manualTime} info='Manual time is a way to add time to your diary without having to track. This must be approved by your manager.'/>
                        <SummaryCard title="Marked Time" cardtime={markedTime} info='Marked time is the total of idle cards you marked so they are counted towards payroll.'/>
                        <SummaryCard title="Approved OT" cardtime={approvedOT} info='The amount of approved Overtime in the wisdom dashboard. This will allow you to track over the project cap, the time still must be tracked via the tracker.'/>
                        <SummaryCard title="Rejected Time" cardtime={rejectedTime} info='A sum of timecards that have been rejected by the manager'/>
                        <SummaryCard title="Overtime" cardtime={overtime} info='Total tracked time that went above the project Cap - This is what is included in the payroll'/>
                        <SummaryCard title="Payroll Time" cardtime={totalTime} info='Tracked time + approved manual time + marked time.'/>
                      </div>
                      <div className="manager-view-employee-summary-chard-card">
                        <h4>Productivity Time</h4>
                        <SummaryChartCard
                          chartTitle="Productivity Score"
                          Productive={activeTime}
                          Idle={idleTime}
                          Manual={manualTime}
                          Overtime={overtime}
                          Total={totalTime}
                          productivityRate={totalTime}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="user-basic-information-container">
                  <div className="user-basic-information-left">
                    <Card className="user-specs-card">
                      <div className="user-specs-header">
                        <div>
                          <h3>User specs</h3>
                          <span>Device and system information</span>
                        </div>
                      </div>

                      {loadingSpecs ? (
                        <p className="user-specs-loading">Loading specs...</p>
                      ) : specs ? (
                        <div className="user-specs-content">
                          <div className="spec-item">
                            <span>OS</span>
                            <strong>{specs.OS}</strong>
                          </div>

                          <div className="spec-item">
                            <span>Type</span>
                            <strong>{specs.Type}</strong>
                          </div>

                          <div className="spec-item">
                            <span>Model</span>
                            <strong>{specs.Model}</strong>
                          </div>

                          <div className="spec-item">
                            <span>CPU</span>
                            <strong>{specs.CPU}</strong>
                          </div>

                          <div className="spec-item">
                            <span>RAM</span>
                            <strong>{specs.RAM} GB</strong>
                          </div>

                          <div className="spec-item">
                            <span>Location</span>
                            <strong>{specs.Location}</strong>
                          </div>
                        </div>
                      ) : (
                        <p className="user-specs-empty">
                          No specs found for this user.
                        </p>
                      )}
                    </Card>

                    <Card className="user-projects-card">
                      <div className="user-projects-header">
                        <div>
                          <h3>User projects</h3>
                          <span>Projects associated with this user</span>
                        </div>
                      </div>

                      {loadingProjects ? (
                        <p className="user-projects-loading">Loading projects...</p>
                      ) : projects?.length > 0 ? (
                        <div className="user-projects-content">
                          {projects.map((project) => (
                            <div className="project-item" key={project.id || project.name}>
                              <div className="project-item-top">
                                <strong>{project.name}</strong>
                                <strong>{project.manager || "Manager Not informed"}</strong>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p className="user-projects-empty">
                          No projects found for this user.
                        </p>
                      )}
                    </Card>

                    <Card className="user-achivements-card">
                      <div className="user-achivements-header">
                        <div>
                          <h3>User achievements</h3>
                          <span>Completed courses <small style={{color:"white"}}>[Course, Duration and Completed date]</small></span>
                        </div>
                      </div>

                      {loadingAchivements ? (
                        <p className="user-achivements-loading">
                          Loading achievements...
                        </p>
                      ) : achivements?.length > 0 ? (
                        <div className="user-achivements-content">
                          {achivements.map((achivement) => (
                            <div
                              className="achivements-item"
                              key={achivement.name}
                            >
                              <div className="achivement-item-top">
                                <strong>{achivement.courseName}</strong>
                                <strong>{achivement.duration}h</strong>
                                <strong>
                                  {achivement.completedAt
                                    ? moment.utc(achivement.completedAt).format("YYYY-MM-DD")
                                    : "Not informed"}
                                </strong>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p className="user-achivements-empty">
                          No achievements found for this user.
                        </p>
                      )}
                    </Card>
                  </div>

                  <div className="user-basic-information-empty" />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default UserSummary;
